import * as XLSX from "xlsx";
import moment from "moment";
import { RenderCommaMoney } from "utils/functions/FormatMoney";

// ค่าตรงกับ API (yamaha_backend/configs/seatBooking.js)
export const SEAT_STATUS = {
  FREE: "1",
  LOCKED: "2",
  PENDING: "3",
  TAKEN: "4",
  BLOCKED: "5",
};

export const BOOKING_STATUS = {
  PENDING: "3",
  APPROVED: "4",
  REJECTED: "5",
  CANCELLED_BY_ADMIN: "8",
};

export const BOOKING_SOURCE = { PAID: "1", INTERNAL: "2" };
export const CREATED_BY = { CUSTOMER: "1", ADMIN: "2" };

export const RENDER_SEAT_STATUS = (status) => {
  switch (status) {
    case SEAT_STATUS.FREE:
      return { label: "ว่าง", color: "#DED0EB", txtColor: "#4b1e78" };
    case SEAT_STATUS.LOCKED:
      return { label: "ลูกค้ากำลังจอง", color: "#FFE2B0", txtColor: "#8a5a00" };
    case SEAT_STATUS.PENDING:
      return { label: "รอยืนยัน", color: "#FFB341", txtColor: "#FFFFFF" };
    case SEAT_STATUS.TAKEN:
      return { label: "ไม่ว่าง (จองแล้ว)", color: "#5c5c5c", txtColor: "#FFFFFF" };
    case SEAT_STATUS.BLOCKED:
      return { label: "กันไว้", color: "#1058cb", txtColor: "#FFFFFF" };
    default:
      return { label: "-", color: "#e4e4e4", txtColor: "#000000" };
  }
};

export const RENDER_SEAT_BOOKING_STATUS = (status) => {
  switch (status) {
    case "1":
      return { labelTh: "กำลังจอง", bgColor: "#e4e4e4", txtColor: "#000000" };
    case "2":
      return { labelTh: "กำลังส่ง", bgColor: "#e4e4e4", txtColor: "#000000" };
    case BOOKING_STATUS.PENDING:
      return { labelTh: "รอตรวจสลิป", bgColor: "#FFEB4C", txtColor: "#595966" };
    case BOOKING_STATUS.APPROVED:
      return { labelTh: "จองสำเร็จ", bgColor: "#33994C", txtColor: "#FFFFFF" };
    case BOOKING_STATUS.REJECTED:
      return { labelTh: "ปฏิเสธ", bgColor: "#D9D9E0", txtColor: "#595966" };
    case "6":
      return { labelTh: "หมดเวลา", bgColor: "#9F9F9F", txtColor: "#FFFFFF" };
    case "7":
      return { labelTh: "ลูกค้ายกเลิก", bgColor: "#9F9F9F", txtColor: "#FFFFFF" };
    case BOOKING_STATUS.CANCELLED_BY_ADMIN:
      return { labelTh: "ยกเลิกโดยแอดมิน", bgColor: "#6e6e6e", txtColor: "#FFFFFF" };
    default:
      return { labelTh: "-", bgColor: "#e4e4e4", txtColor: "#000000" };
  }
};

export const RENDER_BOOKING_SOURCE = (source) =>
  source === BOOKING_SOURCE.INTERNAL ? "ภายใน/VIP" : "จ่ายเงิน";

// ค่าดูที่ API configs/seatBooking.js (ACTION_TYPE)
export const RENDER_SEAT_BOOKING_ACTION = (actionType) => {
  switch (actionType) {
    case "1":
      return { label: "เลือกที่นั่ง", color: "#737b8b" };
    case "2":
      return { label: "แก้ไขที่นั่ง", color: "#737b8b" };
    case "3":
      return { label: "ลูกค้ายกเลิกก่อนส่ง", color: "#9F9F9F" };
    case "4":
      return { label: "หมดเวลาการจอง", color: "#9F9F9F" };
    case "5":
      return { label: "ส่งการจอง + แนบสลิป", color: "#1058cb" };
    case "6":
      return { label: "แนบสลิปเพิ่ม", color: "#1058cb" };
    case "7":
      return { label: "อนุมัติ", color: "#5CB719" };
    case "8":
      return { label: "ปฏิเสธ", color: "#ff0000" };
    case "9":
      return { label: "ย้อนกลับการอนุมัติ", color: "#FFB341" };
    case "10":
      return { label: "ย้อนกลับการปฏิเสธ", color: "#FFB341" };
    case "11":
      return { label: "ยกเลิกโดยแอดมิน", color: "#6e6e6e" };
    case "12":
      return { label: "แอดมินจองให้", color: "#4b1e78" };
    case "13":
      return { label: "สแกนเข้างาน", color: "#008000" };
    default:
      return { label: "อื่น ๆ", color: "#737b8b" };
  }
};

// ข้อความ error จาก API ({ error: { code, message, items } }) เป็นภาษาไทยสำหรับแอดมิน
const ERROR_MESSAGE_BY_CODE = {
  PRICE_LOCKED: "เปลี่ยนราคาไม่ได้ เพราะมีการจองแล้ว",
  SEAT_MAP_LOCKED: "ล้างผังไม่ได้ เพราะมีการจองแล้ว",
  PRESET_NOT_FOUND: "ไม่พบผังสำเร็จรูปนี้",
  SCHOOL_RESERVED: "รหัสโรงเรียน GEN และ GUEST สงวนไว้ให้ระบบ",
  SCHOOL_DUPLICATE: "รหัสโรงเรียนซ้ำ",
  ACCOUNT_INVALID: "เลขบัญชีต้องเป็นตัวเลข 10-15 หลัก (มีขีดได้)",
  ROWS_INVALID: "ไฟล์มีแถวที่ไม่ถูกต้อง",
  SEAT_UNAVAILABLE: "มีที่นั่งที่ไม่ว่างแล้ว",
  SEAT_NOT_FOUND: "ไม่พบที่นั่ง",
  NOTE_REQUIRED: "จองแบบจ่ายเงินที่ไม่มีสลิปต้องใส่หมายเหตุ",
  BOOKER_REQUIRED: "กรุณากรอกชื่อผู้จอง",
  REASON_REQUIRED: "กรุณาระบุเหตุผล",
  NOT_EVENT_DAY: "เช็คเข้างานได้เฉพาะวันงาน",
  TICKET_USED: "ที่นั่งนี้เช็คเข้างานไปแล้ว",
  NOT_CHECKED_IN: "ที่นั่งนี้ยังไม่ได้เช็คเข้างาน",
  TICKET_NOT_VALID: "ใบจองนี้ไม่ได้อยู่ในสถานะจองสำเร็จแล้ว",
  NOT_PENDING: "รายการนี้ไม่ได้อยู่ในสถานะรอตรวจสลิปแล้ว",
  UNDO_NOT_ALLOWED: "ย้อนกลับไม่ได้ (สถานะเปลี่ยน มีตั๋วถูกสแกนแล้ว หรือเป็นรายการที่แอดมินจองให้)",
  CANCEL_NOT_ALLOWED: "ยกเลิกไม่ได้ (สถานะเปลี่ยน หรือมีตั๋วถูกสแกนแล้ว)",
  UPLOAD_INVALID: "ไฟล์ไม่ถูกต้อง (รูปหรือ PDF ไม่เกิน 8 MB)",
};

export const RENDER_SEAT_BOOKING_ERROR = (res, fallback = "เกิดข้อผิดพลาด") => {
  const error = res && res.data && res.data.error;
  if (!error) return fallback;
  const base = ERROR_MESSAGE_BY_CODE[error.code] || error.message || fallback;
  // items ที่เป็นข้อความ (เช่น รายการที่นั่งที่ชน / เงื่อนไข gate) ต่อท้ายให้เห็นเลย
  if (Array.isArray(error.items) && error.items.length && typeof error.items[0] === "string") {
    return `${base}: ${error.items.join(", ")}`;
  }
  return base;
};

// GEN/GUEST เป็นรหัสที่ระบบใช้นำหน้ารหัสจอง (บุคคลทั่วไป / ภายใน-VIP) ไม่ใช่โรงเรียนจริง ห้ามแสดงเป็นชื่อโรงเรียน
export const RENDER_SCHOOL = (code, name) => {
  if (!code || code === "GUEST") return "-";
  if (code === "GEN") return "ไม่ระบุ";
  return name ? `${code} · ${name}` : code;
};

// ยอดโอนในสลิปเทียบกับยอดที่ต้องชำระ (ใบจ่ายเงินที่มีสลิปเท่านั้น)
// status: "ok" ตรง, "mismatch" ไม่ตรง, "unknown" มีสลิปแต่อ่านยอดไม่ได้ (ไม่ได้ตรวจอัตโนมัติ), null ไม่ต้องเช็ค
export const SLIP_AMOUNT_CHECK = (booking) => {
  const payments = (booking && booking.payments) || [];
  if (!payments.length || booking.booking_source !== BOOKING_SOURCE.PAID) return { status: null, paid: null };
  const amounts = payments.map((p) => p.transfer_amount).filter((a) => typeof a === "number");
  if (amounts.length !== payments.length) return { status: "unknown", paid: null };
  const paid = amounts.reduce((sum, a) => sum + a, 0);
  return { status: paid === booking.amount ? "ok" : "mismatch", paid };
};

const PENDING_TOO_LONG_HOURS = 24;

// รวมทุกเรื่องที่แอดมินควรเช็คก่อนตัดสินใจ: คำเตือนจากการตรวจสลิป + ยอดโอนไม่ตรง + ไม่มีสลิป + รอนานเกินที่แจ้งลูกค้าไว้
export const ADMIN_BOOKING_WARNINGS = (booking) => {
  const slip = SLIP_AMOUNT_CHECK(booking);
  const isAmountWarning = (w) => /^ยอดเงินในสลิป/.test(w) || /^ยอดโอนรวม/.test(w);
  const list = (booking.warnings || []).filter((w) => !(slip.status === "mismatch" && isAmountWarning(w)));
  if (slip.status === "mismatch") {
    list.push(`ยอดโอนในสลิปรวม ${RenderCommaMoney(slip.paid)} บาท ไม่ตรงกับยอดที่ต้องชำระ ${RenderCommaMoney(booking.amount)} บาท`);
  }
  if (slip.status === "unknown") list.push("อ่านยอดในสลิปอัตโนมัติไม่ได้ กรุณาเปิดสลิปตรวจยอดเอง");
  if (booking.booking_source === BOOKING_SOURCE.PAID && !(booking.payments || []).length) {
    list.push(`ไม่มีสลิป${booking.note ? ` (หมายเหตุ: ${booking.note})` : ""}`);
  }
  if (
    booking.status === BOOKING_STATUS.PENDING &&
    booking.submitted_at &&
    moment().diff(moment(booking.submitted_at), "hours") >= PENDING_TOO_LONG_HOURS
  ) {
    list.push(`รอตรวจเกิน ${PENDING_TOO_LONG_HOURS} ชม. (ลูกค้าได้รับแจ้งว่าจะตรวจภายใน 24 ชม.)`);
  }
  return [...new Set(list)];
};

// Inputs.UploadImage ส่งรายการไฟล์ทั้งหมดมา ใช้ไฟล์ล่าสุดที่เพิ่งเลือก
export const LAST_NEW_FILE = (files) =>
  [...(files || [])].reverse().find((file) => file.isNewUpload && !file.isDelete) || null;

// ---------- Excel ----------

const downloadSheet = (fileName, sheets) => {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), name);
  });
  XLSX.writeFile(wb, fileName);
};

export const SEAT_TEMPLATE_HEADERS = ["Zone", "Row", "Seat No.", "Col"];

// template = ผังสำเร็จรูปจาก API (GET /admin/seat-presets) ที่เดียวกับปุ่ม "ใช้ผังนี้" ไม่เก็บผังซ้ำฝั่ง portal
export const DOWNLOAD_SEAT_TEMPLATE = (preset) => {
  const presetRows = preset.rows.map((r) => [r.zone, r.row, r.seat_no, r.col]);
  return downloadSheet("Seat_Template.xlsx", [
    {
      name: "Seats",
      rows: [SEAT_TEMPLATE_HEADERS, ...presetRows],
    },
    {
      name: "สรุป",
      rows: [
        ["โซน", "ชื่อโซน (ใส่ในหน้าตั้งค่า > ชื่อโซน)", "จำนวนที่นั่ง", "แถว"],
        ...preset.zone_names.map(({ zone, name }) => {
          const seats = presetRows.filter((r) => r[0] === zone);
          return [zone, name, seats.length, [...new Set(seats.map((r) => r[1]))].join(", ")];
        }),
        ["รวม", "", presetRows.length, ""],
        [],
        [`ผังตาม ${preset.name} (SIAM PHATUMWAN HOUSE THEATRE) ฮอลล์อื่นแก้แถวในแผ่น Seats ได้เลย`],
      ],
    },
    {
      name: "คำอธิบาย",
      rows: [
        ["คอลัมน์", "คำอธิบาย"],
        ["Zone", "รหัสโซน เช่น A, B1, B2, C1, C2"],
        ["Row", "แถว เช่น A, B, C"],
        ["Seat No.", "เลขที่นั่ง (ตัวเลข) ระบบสร้างรหัสที่นั่งให้เป็น {Zone}-{Row}{เลข 2 หลัก} เช่น B1-A01"],
        ["Col", "ไม่บังคับ ตำแหน่งช่องในแถว (1-999) ใช้วาดผังให้เหมือนจริง เช่น เว้นทางเดิน: ที่นั่ง 1,2 อยู่ช่อง 1,2 ที่นั่ง 3 อยู่ช่อง 5"],
        ["", "ถ้าทั้งโซนไม่ใส่ Col ที่นั่งจะเรียงชิดกันตามเลขที่นั่ง ถ้าใส่บางที่ ที่ไม่ใส่จะใช้เลขที่นั่งเป็นตำแหน่ง"],
        ["", "หนึ่งแถวต่อหนึ่งที่นั่ง นำเข้าซ้ำได้ ที่นั่งที่มีอยู่แล้วไม่ถูกแก้สถานะ แต่ Col จะเปลี่ยนตามไฟล์ล่าสุด"],
      ],
    },
  ]);
};

export const BOOKING_TEMPLATE_HEADERS = [
  "กลุ่มการจอง",
  "ประเภท",
  "รหัสโรงเรียน",
  "ชื่อผู้จอง",
  "นามสกุล",
  "เบอร์โทร",
  "อีเมล",
  "อีเมลสมาชิก",
  "ที่นั่ง",
  "ชื่อผู้ชม",
  "หมายเหตุ",
];

export const DOWNLOAD_BOOKING_TEMPLATE = () =>
  downloadSheet("Booking_Template.xlsx", [
    {
      name: "Bookings",
      rows: [
        BOOKING_TEMPLATE_HEADERS,
        ["G1", "จ่ายเงิน", "SCH01", "โรงเรียนตัวอย่าง", "", "0812345678", "", "", "B1-A01", "ด.ช. ตัวอย่าง", "โอนรวม"],
        ["G1", "จ่ายเงิน", "", "", "", "", "", "", "B1-A02", "", ""],
        ["G2", "ไม่จ่ายเงิน", "", "แขกผู้ใหญ่", "", "", "", "", "A-B14", "คุณแขก", ""],
      ],
    },
    {
      name: "คำอธิบาย",
      rows: [
        ["คอลัมน์", "คำอธิบาย"],
        ["กลุ่มการจอง", "แถวที่ใส่ค่าเดียวกัน = การจองใบเดียวกัน (หนึ่งแถวต่อหนึ่งที่นั่ง)"],
        ["ประเภท", "จ่ายเงิน หรือ ไม่จ่ายเงิน (ภายใน/VIP)"],
        ["รหัสโรงเรียน", "ไม่บังคับ ว่าง = ไม่ระบุโรงเรียน ใช้ได้ทั้งแบบจ่ายเงินและไม่จ่ายเงิน (รหัสจองแบบไม่จ่ายเงินขึ้นต้น GUEST)"],
        ["ชื่อผู้จอง/นามสกุล/เบอร์โทร/อีเมล", "ใส่ที่แถวแรกของกลุ่ม ชื่อผู้จองบังคับ"],
        ["อีเมลสมาชิก", "ไม่บังคับ ถ้าใส่ ระบบผูกการจองกับบัญชีสมาชิก ลูกค้าจะเห็นตั๋วในแอป"],
        ["ที่นั่ง", "รหัสที่นั่ง เช่น B1-A01 ต้องว่างหรือกันไว้"],
        ["หมายเหตุ", "ประเภทจ่ายเงินบังคับ (นำเข้าไม่มีสลิป) เช่น โอนรวม"],
        ["", "ตรวจทั้งไฟล์ก่อน ผิดแถวเดียวจะไม่นำเข้าเลย การจองที่นำเข้าอนุมัติทันที"],
      ],
    },
  ]);

// blankrows: true ให้ลำดับตรงกับแถวใน Excel (แถว 1 = หัวตาราง ข้อมูลแถวแรก = แถว 2) ก่อนกรองแถวว่างทิ้ง
const readFirstSheet = async (file) => {
  const wb = XLSX.read(await file.arrayBuffer(), { type: "array" });
  return XLSX.utils
    .sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "", blankrows: true })
    .map((row, index) => ({ row, excelRow: index + 2 }));
};

// หัวคอลัมน์รับทั้งตาม template และชื่อที่ใกล้เคียง (ตัวพิมพ์เล็ก/ใหญ่ ช่องว่าง ไม่มีผล)
const normalizeKey = (key) => String(key).toLowerCase().replace(/[\s._]/g, "");
const pick = (row, aliases) => {
  const map = Object.fromEntries(Object.keys(row).map((k) => [normalizeKey(k), row[k]]));
  const found = aliases.map(normalizeKey).find((alias) => map[alias] !== undefined);
  return found ? String(map[found]).trim() : "";
};

export const PARSE_SEAT_FILE = async (file) =>
  (await readFirstSheet(file))
    .map(({ row, excelRow }) => ({
      excel_row: excelRow,
      zone: pick(row, ["Zone", "โซน"]),
      row: pick(row, ["Row", "แถว"]),
      seat_no: pick(row, ["Seat No.", "Seat No", "SeatNo", "เลขที่นั่ง"]),
      col: pick(row, ["Col", "Column", "ตำแหน่ง"]),
    }))
    .filter((r) => r.zone || r.row || r.seat_no);

export const PARSE_BOOKING_FILE = async (file) =>
  (await readFirstSheet(file))
    .map(({ row, excelRow }) => ({
      excel_row: excelRow,
      group: pick(row, ["กลุ่มการจอง", "group"]),
      type: pick(row, ["ประเภท", "type"]),
      school_code: pick(row, ["รหัสโรงเรียน", "school_code"]),
      first_name: pick(row, ["ชื่อผู้จอง", "first_name"]),
      last_name: pick(row, ["นามสกุล", "last_name"]),
      phone: pick(row, ["เบอร์โทร", "phone"]),
      email: pick(row, ["อีเมล", "email"]),
      member_email: pick(row, ["อีเมลสมาชิก", "member_email"]),
      seat_id: pick(row, ["ที่นั่ง", "seat_id"]),
      viewer_name: pick(row, ["ชื่อผู้ชม", "viewer_name"]),
      note: pick(row, ["หมายเหตุ", "note"]),
    }))
    .filter((r) => r.group || r.seat_id);
